// removed by extract-text-webpack-plugin
module.exports = {"Main":"src-containers-Inventory-__InventoryPage-module___Main"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Inventory/InventoryPage.module.css
// module id = 1257
// module chunks = 1